import React, { Component } from 'react'
import { FormattedMessage, injectIntl, defineMessages } from 'react-intl'
import Select from 'react-select'
import { AppContext } from "@lightspeed-invoicing/core-client/frontend";

class OrderStatusContentInput extends Component {

    constructor(props, context) {
        super(props, context)
        const content = this.props.value || {}
        this.state = {
            className: this.props.className || '',
            onChange: this.props.onChange || function () { },
            displayedStatuses: content.displayedStatuses || [],
        }
        this.handleDisplayedStatuses = this.handleDisplayedStatuses.bind(this)
    }

    triggerChanged() {
        this.state.onChange({
            displayedStatuses: this.state.displayedStatuses
        })
    }

    componentDidMount() {
        if (this.state.displayedStatuses.length === 0) {
            this.setState({
                displayedStatuses: AppContext.getOrderStatusesByType('ordered').map(s => s.id)
            })
        }
    }

    componentWillReceiveProps(nextProps) {
        const content = nextProps.value || {}
        this.setState({
            displayedStatuses: content.displayedStatuses || [],
        })
    }

    handleDisplayedStatuses(statuses) {
        this.setState({
            displayedStatuses: statuses.map(option => {
                return option.value
            }),
        }, this.triggerChanged)
    }

    render() {
        return (
            <div>
                <div className="row">
                    <div className="col-3">
                        <label className="mb-0" htmlFor="hideCreditMemos">
                            <FormattedMessage
                                id="templates.sections.form.edit.content.order_status.status_to_display_label"
                                defaultMessage="Status to display"
                            />
                        </label>
                    </div>
                    <div className="col-9">
                        <Select
                            searchable={false}
                            multi
                            value={this.state.displayedStatuses}
                            onChange={this.handleDisplayedStatuses}
                            options={AppContext.getOrderStatusesByType('ordered').map(s => {
                                return {
                                    label: s.attributes.name,
                                    value: s.id
                                }
                            })}
                        />
                        <small className="form-text text-muted">
                            <FormattedMessage
                                id="templates.sections.form.edit.content.order_status.status_to_display_description"
                                defaultMessage="You can specify in progress status that you which to display on the timeline"
                            />
                        </small>

                    </div>
                </div>
            </div>
        );
    }
}

export default injectIntl(OrderStatusContentInput)


// WEBPACK FOOTER //
// ./src/template/sections/content/order-status/input.component.jsx